// Pure helpers for splitting an expense/income line into N entries.
// Kept free of util-formaters imports so they stay unit-testable under vitest.

/**
 * Divide a subtotal into `count` shares rounded to 2 decimals.
 * Any rounding remainder is added to the last share so the shares sum exactly
 * to the subtotal (mirrors the payroll advance split behaviour).
 *
 * @param {number} subtotal - the (already parsed) line subtotal to divide
 * @param {number} count - number of entries to split into
 * @returns {number[]} array of `count` shares
 */
export function computeSplitAmounts(subtotal, count) {
    const total = Number(subtotal) || 0
    const n = Math.max(1, Math.floor(count))
    const base = Math.round((total / n) * 100) / 100

    const shares = []
    for (let i = 0; i < n; i++) {
        const share = i === n - 1
            ? Math.round((total - base * (n - 1)) * 100) / 100
            : base
        shares.push(share)
    }
    return shares
}

/**
 * Zero-padded "NN/XX" label so split entries sort correctly by ASCII
 * (e.g. 01/12, 02/12 … 12/12). Padding width tracks the number of digits in
 * `count`, so single-digit splits stay unpadded.
 *
 * @param {number} index - 1-based entry index
 * @param {number} count - total number of entries
 * @returns {string}
 */
export function buildSplitLabel(index, count) {
    const width = String(count).length
    return `${String(index).padStart(width, '0')}/${count}`
}
